import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { type I18nLocale, t, type WithI18nLocale } from '@ardoq/i18n';

type NotEnoughComponentsDoqProps = WithI18nLocale;

export const NotEnoughComponentsDoq = ({
  i18nLocale,
}: NotEnoughComponentsDoqProps) => (
  <EmptyStatesDoqContainer
    data-testid={`${DoqType.SPIDER_CHART}-emptystate__not-enough-components`}
  >
    <ResponsiveDoqWithSpeechBubble
      doqType={DoqType.SPIDER_CHART}
      title={t(
        i18nLocale,
        'tabview:spiderChart.emptyState.noData',
        'There is no data to show'
      )}
      message={t(
        i18nLocale,
        'tabview:spiderChart.emptyState.notEnoughComponentsMessage',
        'Select a context with multiple children to see a Spider Chart.'
      )}
    />
  </EmptyStatesDoqContainer>
);

type NoSelectedFieldsProps = {
  onButtonClick: VoidFunction;
  buttonLabel?: string;
  i18nLocale: I18nLocale;
};

export const NoSelectedFields = ({
  onButtonClick,
  buttonLabel,
  i18nLocale,
}: NoSelectedFieldsProps) => (
  <EmptyStatesDoqContainer
    data-testid={`${DoqType.SPIDER_CHART}-emptystate__no-selected-fields`}
  >
    <ResponsiveDoqWithSpeechBubble
      doqType={DoqType.SPIDER_CHART}
      title={t(
        i18nLocale,
        'tabview:spiderChart.emptyState.noData',
        'There is no data to show'
      )}
      message={t(
        i18nLocale,
        'tabview:spiderChart.emptyState.noSelectedFieldsMessage',
        'Select at least one field to see a Spider Chart.'
      )}
      buttonLabel={buttonLabel}
      onButtonClick={onButtonClick}
    />
  </EmptyStatesDoqContainer>
);
